import { environment } from '@env';
import { OlEdition, resolveOlEdition } from '@ol/kit';

export type OlAccountConfigBase = {
  authServiceUrl: string;
  backofficeUrl: string;
  backendDomain: string;
  runtimeServiceUrl: string;
  edition: OlEdition;
};

export function buildOlAccountConfigBase(): OlAccountConfigBase {
  return {
    authServiceUrl: environment.AUTH_SERVICE_URL,
    backofficeUrl: environment.BACKOFFCIE_URL,
    backendDomain: environment.BACKEND_DOMAIN,
    runtimeServiceUrl: environment.RUNTIME_SERVICE_URL,
    edition: resolveOlEdition(environment),
  };
}
